import script from "./NiftyLevel.vue?vue&type=script&setup=true&lang=js"
export * from "./NiftyLevel.vue?vue&type=script&setup=true&lang=js"

import "./NiftyLevel.vue?vue&type=style&index=0&id=f9ac8c36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9ac8c36"]])

export default __exports__